import GenericModal from '../../../Components/GenericModal'
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
} from '@mui/material'
import { useMutation, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import * as React from 'react'
import { useState } from 'react'
import StudyService from '../../../APIs/Python/APIs/StudyService'
import { useParams } from 'react-router-dom'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useFilteredProtocols } from '../Protocols/ProtocolFns'

function ProtocolModal({ open, setOpen }: { open: boolean; setOpen: any }) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const { study_id } = useParams()

  const [filter, setFilter] = useState(true)
  const [protocol, setProtocol] = useState<undefined | number>(undefined)
  const protocolQuery = useFilteredProtocols(open, filter)

  const { mutate: updateProtocol } = useMutation<any, AxiosResponse>(
    () => StudyService.addProtocol(whoAmI, study_id!, protocol!),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/study'],
        })
      },
    },
  )

  return (
    <GenericModal
      open={open}
      loading={protocolQuery.isLoading}
      error={protocolQuery.error}
      setClose={() => {
        setOpen(false)
        setProtocol(undefined)
      }}
      setCommit={
        protocol ?
          () => {
            setOpen(false)
            setProtocol(undefined)
            updateProtocol()
          }
        : undefined
      }
      title={'Associate New Protocol'}
    >
      <Box sx={{ pt: 1, width: 1, display: 'flex' }}>
        <Autocomplete
          fullWidth
          options={protocolQuery.data}
          autoHighlight
          getOptionLabel={(option) => option.EthicsNumber}
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option.EthicsNumber}
            </Box>
          )}
          onChange={(event: any, newValue) => {
            setProtocol(newValue?.ProtocolID)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose a protocol"
              inputProps={{
                ...params.inputProps,
              }}
            />
          )}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={filter}
              onChange={(e) => setFilter(e.target.checked)}
              color={'primary'}
            />
          }
          label="Filter Garvan"
          labelPlacement="start"
          sx={{ ml: '1', display: 'flex' }}
        />
      </Box>
    </GenericModal>
  )
}

export default ProtocolModal
